import { defineKey as T } from 'ha/i18n';

export const ACTION_PREFIX = 'LISTING_CALENDAR';
export const STATE_NAME = 'listingCalendar';

export const Actions = {
  LOAD_LISTING_START: `${ACTION_PREFIX}/LOAD_LISTING_START`,
  LOAD_LISTING_DONE: `${ACTION_PREFIX}/LOAD_LISTING_DONE`,
  LOAD_LISTING_FAIL: `${ACTION_PREFIX}/LOAD_LISTING_FAIL`,

  UPDATE_LISTING_EXCLUSIONS_DONE: `${ACTION_PREFIX}/UPDATE_LISTING_EXCLUSIONS_DONE`,
  UPDATE_LISTING_EXCLUSIONS_FAIL: `${ACTION_PREFIX}/UPDATE_LISTING_EXCLUSIONS_FAIL.error`,
  SET_LISTING_EXCLUSIONS_DECLINE_TOKEN: `${ACTION_PREFIX}/SET_LISTING_EXCLUSIONS_DECLINE_TOKEN`,
  UNSET_LISTING_EXCLUSIONS_DECLINE_TOKEN: `${ACTION_PREFIX}/UNSET_LISTING_EXCLUSIONS_DECLINE_TOKEN`,

  CHANGE_CURRENT_YEAR: `${ACTION_PREFIX}/CHANGE_CURRENT_YEAR`,

  CHANGE_FOCUSED_INPUT: `${ACTION_PREFIX}/CHANGE_FOCUSED_INPUT`,
  RESET_FOCUSED_INPUT: `${ACTION_PREFIX}/RESET_FOCUSED_INPUT`,

  REMOVE_ICS_START: `${ACTION_PREFIX}/REMOVE_ICS_START`,
  REMOVE_ICS_DONE: `${ACTION_PREFIX}/REMOVE_ICS_DONE`,
  REMOVE_ICS_FAIL: `${ACTION_PREFIX}/REMOVE_ICS_FAIL`,

  LOAD_BOOKABLE_PERIODS_START: `${ACTION_PREFIX}/LOAD_BOOKABLE_PERIODS_START`,
  LOAD_BOOKABLE_PERIODS_DONE: `${ACTION_PREFIX}/LOAD_BOOKABLE_PERIODS_DONE`,
  LOAD_BOOKABLE_PERIODS_FAIL: `${ACTION_PREFIX}/LOAD_BOOKABLE_PERIODS_FAIL`,
};

export const ExclusionsTypes = {
  AVAILABLE: 'available',
  BLOCKED: 'blocked',
};

export const Messages = {
  LISTING_EXCLUSION_DATES_UPDATE_ERROR: T(
    'We could not update your listing. Please try again!',
  ),
};

export const YEARS_TO_SHOW = 2;
